/* This file is autogenerated, see readme.md for instructions */
import AxisLimtSvgIcon from '@bloomreach/banana-theme/icons/axis-limt.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const AxisLimtIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <AxisLimtSvgIcon />
    </Icon>
  );
});

AxisLimtIcon.displayName = 'AxisLimtIcon';

export default AxisLimtIcon;
